import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigurationModel } from '../+state/common.models';
import { CommonState } from '../+state/common.reducer';
import { Store } from '@ngrx/store';
import { getCommonState } from '../+state/common.selectors';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(public http: HttpClient, private store: Store<CommonState>) {}

  loadConfig() {
    return this.http.get<ConfigurationModel>('./assets/config.json');
  }

  getConfig() {
    return this.store.select(getCommonState);
  }
}
